
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ElementRef, QueryList, ViewChildren, HostListener } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

@Component({
	selector: 'app-shared-validation-code',
	templateUrl: './shared-validation-code.component.html',
	styleUrls: ['./shared-validation-code.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SharedValidationCodeComponent implements OnInit {
	public form: FormGroup;
	public textCodeSent = '';

	@Input() phone = '';
	@Input() email = '';
	@Input() headerTxt = '';
	@Output() resendEmitter = new EventEmitter<any>();
	@Output() notReceivedEmitter = new EventEmitter<any>();
	@Output() submitEmitter = new EventEmitter<any>();
	@Output() cancelEmitter = new EventEmitter<any>();
	@ViewChildren('input') inputs: QueryList<ElementRef>;
	@HostListener('paste', ['$event']) blockPaste = (e: KeyboardEvent) => e.preventDefault();
	@HostListener('copy', ['$event']) blockCopy = (e: KeyboardEvent) => e.preventDefault();
	@HostListener('cut', ['$event']) blockCut = (e: KeyboardEvent) => e.preventDefault();

	constructor(
		private formBuilder: FormBuilder,
	) {}

	ngOnInit(): void {
		this.buildForm();

		this.defineTextCodeSent();
	}

	resend() {
		this.form.reset();
		this.resendEmitter.emit();
	}

	notReceived() {
		this.notReceivedEmitter.emit();
	}

	confirm() {
		const code =
			this.form.get('numberOne').value.toString() +
			this.form.get('numberTwo').value.toString() +
			this.form.get('numberThree').value.toString() +
			this.form.get('numberFour').value.toString() +
			this.form.get('numberFive').value.toString() +
			this.form.get('numberSix').value.toString();

		this.submitEmitter.emit(code);
	}

	cancel() {
		this.cancelEmitter.emit();
	}

	buildForm() {
		this.form = this.formBuilder.group({
			numberOne: ['', [Validators.required]],
			numberTwo: ['', [Validators.required]],
			numberThree: ['', [Validators.required]],
			numberFour: ['', [Validators.required]],
			numberFive: ['', [Validators.required]],
			numberSix: ['', [Validators.required]],
		});
	}

	keypress(event: any, input: string, index: number) {
		event.preventDefault();
		const newValue = event.key;
		const value = this.form.get(input).value ? this.form.get(input).value.toString() : undefined;
		const charCode = (event.which) ? event.which : event.keyCode;

		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return;
		}

		if (!value) {
			this.form.get(input).setValue(newValue);

			if (index < 6) {
				this.inputs.toArray()[index++].nativeElement.focus();
			}
		}
	}

	defineTextCodeSent() {
		if (this.email) {
			this.textCodeSent = 'para o endereço de e-mail';
		} else {
			this.textCodeSent = 'por SMS para o número';
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/sms-validation-signature/shared-validation-code.component.ts